<template>
    <div>
        <v-select :multiple="true" :options="optionsCanales" :placeholder="'Selecciona '+placeholderm"
                  v-model="selectedCanales" @input="setCambio"></v-select>
    </div>
</template>

<script>
export default {
    name: "canal",
    props:{
        placeholderm:String,
    },
    data(){
        return{
            selectedCanales:[],
            optionsCanales:[]
        }
    },
    mounted() {
        this.getGestores();
    },
    methods:{
        getGestores(){ let $this = this;
            axios
                .post('/api/AdminCatalogos/canalesSelectM')
                .then(function (r){
                    $this.optionsCanales = r.data;
                });
        },
        setCambio(){
            this.$emit('cambioCanal');
        }

    }
}
</script>

<style scoped>

</style>
